import { ClbIcon } from "@celebration/react/ClbIcon/ClbIcon";
import type { ClbIconProps } from "@celebration/react/ClbIcon/ClbIcon.types";

type IconsProps = Pick<
  ClbIconProps,
  "icon" | "size" | "style" | "className" | "onClick"
>;

const Icons: React.FC<IconsProps> = (props) => <ClbIcon {...props} />;

export default Icons;
export type { IconsProps };
